import React from 'react';
import Orders from '../../../../../components/page/orders/Orders';

export default function OrdersVendor() {
	return (
		<>
			<Orders />
		</>
	);
}
